import { useState } from "react";

/**
 * 绘图相关状态 Hook
 */
const useDiagramState = () => {
  const [diagramXML, setDiagramXML] = useState('');
  const [diagramMessages, setDiagramMessages] = useState([]);
  const [isDiagramStreaming, setIsDiagramStreaming] = useState(false);
  const [diagramFileId, setDiagramFileId] = useState(null);
  const [isDrawingFullscreen, setIsDrawingFullscreen] = useState(false);

  // 重置绘图状态
  const resetDiagramState = () => {
    setDiagramXML('');
    setDiagramMessages([]);
    setIsDiagramStreaming(false);
    setDiagramFileId(null);
    setIsDrawingFullscreen(false);
  };

  return {
    diagramXML,
    setDiagramXML,
    diagramMessages,
    setDiagramMessages,
    isDiagramStreaming,
    setIsDiagramStreaming,
    diagramFileId,
    setDiagramFileId,
    isDrawingFullscreen,
    setIsDrawingFullscreen,
    resetDiagramState,
  };
};

export default useDiagramState;
